export const translations = {
  no: {
    nav: {
      subtitle: "Rådgivende ingeniører VVS",
      home: "Hjem",
      projects: "Prosjekter",
      services: "Tjenester",
      office: "Kontoret",
      about: "Om oss",
      contact: "Kontakt",
      cta: "Be om tilbud",
    },
    hero: {
      badge: "Rådgivende ingeniører · VVS · BIM",
      headline: ["Presis VVS-", "prosjektering", "for norske bygg"],
      sub: "Norgesconsult leverer prosjektering innen varme, kjøling, ventilasjon, sanitær og sprinkler — fra konsept og beregninger til koordinerte 3D-modeller, arbeidstegninger og som-bygget dokumentasjon.",
      cta1: "Diskuter ditt prosjekt",
      cta2: "Se referanseprosjekter",
      stats: [
        { value: "TK3", label: "Ansvarsrett", sub: "Varme- og kuldeinstallasjoner" },
        { value: "Revit / MagiCAD", label: "Full 3D-prosjektering", sub: "Kollisjonskontrollert leveranse" },
        { value: "2017–2026", label: "Dokumenterte referanser", sub: "Fra brannstasjon til industri" },
      ],
      captionTitle: "Tegningsgjennomgang",
      captionText: "Problemløsning over bordet — og digitalt",
      imageAlt: "Ingeniører rundt møtebord med tekniske tegninger",
    },
    marquee: ["Ventilasjon", "Varme", "Kjøling", "Sanitær", "Sprinkler", "BIM / 3D-modellering", "Energioptimalisering", "Arbeidstegninger"],
    projects: {
      badge: "01 — Referanseprosjekter",
      title: "Dokumentert erfaring fra krevende bygg",
      intro: "Fra samfunnskritiske beredskapsbygg og skoler til stor industri — våre ingeniører har hatt lead- og kontrollroller i prosjekter med høy teknisk kompleksitet.",
      featuredLabel: "Hovedreferanse",
      list: [
        {
          id: "sandnes-brannstasjon",
          name: "Sandnes brannstasjon – hovedstasjon",
          client: "Rogaland brann og redning IKS",
          location: "Sandnes",
          year: "2017",
          size: "ca. 12 700 m² · tre bygg",
          badge: "Beredskapsbygg · Tiltaksklasse 3",
          scope: "Ny hovedstasjon samlokalisert med legevakt, ambulansesentral og øyeblikkelig hjelp – et samfunnskritisk bygg med høye krav til driftssikkerhet og beredskap.",
          role: "Lead-prosjektering av varme- og kuldeinstallasjoner (TK3), fagkontroll og teknisk koordinering.",
          tech: ["ca. 1,08 MW varme", "450 kW varmepumpe/kjøler", "ca. 570 kW kjøling", "Energibrønner og frikjøling"],
          image: "/projects/brannstasjon.jpg",
          credit: "Foto: Rogaland brann og redning IKS",
        },
        {
          id: "husnes-barneskule",
          name: "Ny Husnes barneskule",
          client: "Kvinnherad kommune",
          location: "Husnes",
          year: "2025",
          size: "ca. 4 200 m² · 250 elever",
          badge: "Skole · Passivhus",
          scope: "Ny barneskole i passivhusstandard med energiklasse A og forventet BREEAM Very Good – levert tre måneder før fristen.",
          role: "Senior lead engineer og fagkontroll (design checker) for sanitær-, energi- og hydroniske systemer.",
          tech: ["86 kW varmepumper med bergvarme", "Fem energibrønner", "Frikjøling til ventilasjonsaggregater", "135 kW elektrisk spiss-/reservekjele"],
          image: "/projects/husnes.jpg",
          credit: "Foto: bygg.no / Rune Werner Molnes",
        },
        {
          id: "strand-vgs",
          name: "Strand videregående skole",
          client: "Rogaland fylkeskommune",
          location: "Tau",
          year: "2025–2026",
          size: "Rehabilitering og nybygg",
          badge: "Utdanning · Pågående",
          scope: "Utbygging og rehabilitering av skolen mot over 800 elever, med nye verkstedlokaler for teknologi- og industrifag og elektro.",
          role: "Senior lead engineer, fagkontroll og teknisk koordinering av VVS/RIV-underlaget.",
          tech: ["Beregnet varmebehov ca. 268 kW", "Sentral varmeveksler 305 kW", "Fem vannbårne systemer", "100 kW elektrisk spiss-/reservekjele"],
          image: "/projects/strand-vgs.png",
          credit: "Illustrasjon: Rogaland fylkeskommune",
        },
        {
          id: "pepsico-copernicus",
          name: "PepsiCo Frito-Lay – «Copernicus»",
          client: "PepsiCo / Frito-Lay",
          location: "Środa Śląska, Polen",
          year: "2020–2023",
          size: "ca. 54 700 m² produksjon og lager",
          badge: "Industri · Prosesskjøling",
          scope: "Stort industrielt produksjons- og lageranlegg for næringsmiddelproduksjon – et av Europas mest bærekraftige anlegg i sitt slag.",
          role: "HVAC concept design lead, fagkontroll og detaljprosjektering av kuldesystemet.",
          tech: ["Kjølesentral ca. 4,2 MW", "2,28 MW absorpsjonskjøler", "2 × 783 kW skruekjølere (backup)", "Kjøletårn, hydraulikk og redundans"],
          image: "/projects/pepsico.jpg",
          credit: "Foto: wroclaw.pl",
        },
        {
          id: "svortland-legesenter",
          name: "Øyane Helsehamn – legesenter",
          client: "Hellvik Eiendom AS",
          location: "Svortland, Bømlo",
          year: "2024",
          size: "ca. 1 000 m² · 12 legekontor",
          badge: "Helse · Legesenter",
          scope: "Nytt legesenter med 12 legekontor, laboratorium og ultralydrom – samlokalisering av Kystlegane og Bremnes legesenter under ett tak.",
          role: "Senior lead engineer og fagkontroll (design checker) for de tekniske anleggene.",
          tech: ["Lavtemperatur vannbåren gulvvarme", "Lokale kjølesystemer", "Energieffektiv drift"],
          image: "/projects/svortland.jpg",
          credit: "Foto: Simon Knutsson Sortland / Bømlo kommune",
        },
      ],
    },
    services: {
      badge: "02 — Komplett VVS-leveranse",
      title: "Våre tjenester innen VVS-prosjektering",
      intro: "Fra beregninger og systemvalg til Revit-modeller, arbeidstegninger, produksjonsunderlag og som-bygget dokumentasjon.",
      showDetails: "Se detaljer",
      hideDetails: "Skjul detaljer",
      items: [
        {
          id: "ventilasjon",
          code: "VVS-01",
          name: "Ventilasjon og luftbehandling",
          short: "Luftmengder, aggregater, sjakter og koordinert kanalnett for godt inneklima.",
          details: ["Beregning av luftmengder og trykkfall", "Dimensjonering av aggregater og kanalnett i 3D", "Koordinering av sjaktføringer og tekniske rom", "Brannstrategi og tverrfaglig koordinering"],
        },
        {
          id: "varme",
          code: "VVS-02",
          name: "Varme og kjøling",
          short: "Energisentraler, varmepumper, kjølemaskiner, fjernvarme og vannbårne distribusjonssystemer.",
          details: ["Hydraulikk, kapasiteter og rørdimensjonering", "Trykktapsberegning og innregulering", "Varmepumper, varmevekslere og spisslast", "Tekniske sentraler og energifordeling"],
        },
        {
          id: "sanitar",
          code: "VVS-03",
          name: "Sanitær og VA i bygg",
          short: "Tappevann, avløp, overvann, pumpeanlegg og tekniske rom.",
          details: ["Dimensjonering av tappevann og sirkulasjon", "Spillvann, lufting og overvannshåndtering", "Trykkøknings- og pumpeanlegg", "Systemløsninger for krevende bygg"],
        },
        {
          id: "brann",
          code: "VVS-04",
          name: "Brannbeskyttelse",
          short: "Sprinkler, hydrant- og slokkeanlegg med nødvendig tverrfaglig koordinering.",
          details: ["Sprinkleranlegg etter gjeldende standarder", "Hydrant- og slokkeanlegg", "Koordinering mot arkitekt og konstruksjon", "Dokumentasjon for brannkonsept"],
        },
        {
          id: "arbeidstegninger",
          code: "VVS-05",
          name: "Arbeidstegninger og dokumentasjon",
          short: "Klare, koordinerte arbeidstegninger og teknisk dokumentasjon – klare for utførelse.",
          details: ["Produksjon av arbeidstegninger og detaljer", "Systemskjemaer og funksjonsbeskrivelser", "Underlag tilpasset utførende og byggeplass", "Revisjon og kvalitetskontroll før publisering"],
        },
        {
          id: "bim",
          code: "VVS-06",
          name: "BIM og rådgivning",
          short: "Revit/MagiCAD, modellkontroll, kollisjonsanalyse, mengder og BIM-koordinering.",
          details: ["Fagmodell med riktig geometri og informasjon", "Kollisjonskontroll og avviksoppfølging", "Mengdegrunnlag og komponentlister", "BIM-koordinering mot øvrige fag"],
        },
      ],
    },
    carousel: {
      badge: "03 — Inne på kontoret",
      title: "Slik arbeider vi — hver eneste dag",
      intro: "Tegninger på møtebordet, 3D-modeller på skjermene og faglige diskusjoner. Det er her de byggbare løsningene blir til.",
      slides: [
        {
          title: "Problemløsning rundt bordet",
          category: "DETALJPROSJEKTERING",
          description: "De beste løsningene skapes i møte mellom folk — rundt bordet med tegninger og utkast, og digitalt i felles modell. Vi peker, diskuterer føringsveier og avklarer grensesnitt mot arkitekt, konstruksjon og elektro før underlaget publiseres.",
          badge: "Rundt bordet · Digitalt · Tverrfaglig kontroll",
        },
        {
          title: "3D- og BIM-modellering",
          category: "DIGITAL BYGNINGSMODELL",
          description: "Ventilasjonskanaler, rørgater og tekniske rom modelleres i Revit og MagiCAD med millimeterpresisjon — kollisjoner avklares på skjerm, ikke på byggeplass.",
          badge: "Revit MEP · MagiCAD · Kollisjonskontroll",
        },
        {
          title: "Beregninger ved tegnebordet",
          category: "SYSTEMUTVIKLING",
          description: "Trykkfall, luftmengder og dimensjonering regnes gjennom og kontrolleres av erfarne rådgivere før underlaget sendes til fagkontroll og godkjenning.",
          badge: "Luftmengder · Dimensjonering · Systemanalyse",
        },
        {
          title: "Fra tegning til teknisk anlegg",
          category: "VVS I PRAKSIS",
          description: "Det vi tegner skal kunne bygges. Rørføringer, manifoldfordelere og tekniske sentraler detaljprosjekteres slik at montøren kan montere direkte fra underlaget — uten gjetting på byggeplassen.",
          badge: "Tekniske rom · Rørføringer · Byggbart underlag",
        },
      ],
    },
    process: {
      badge: "04 — Vår prosess",
      title: "Fra oppstart til godkjent leveranse",
      steps: [
        { title: "Oppstart og kravavklaring", desc: "Vi avklarer omfang, standarder, milepæler og grensesnitt." },
        { title: "Beregning og systemdesign", desc: "Forutsetninger, kapasiteter og tekniske prinsipper dokumenteres." },
        { title: "BIM-modell og koordinering", desc: "Revit/MagiCAD, kollisjonskontroll og tverrfaglige avklaringer." },
        { title: "Fagkontroll og publisering", desc: "Sjekklister, revisjonskontroll og godkjent tegningspakke." },
        { title: "Oppfølging og som bygget", desc: "Endringer innarbeides og sluttdokumentasjon ferdigstilles." },
      ],
      deliverablesLabel: "Typisk leveransepakke:",
      deliverables: ["Beregninger", "BIM-modell", "Skjemaer", "Tegninger", "Mengder", "Kontrollspor"],
    },
    about: {
      badge: "05 — Om Norgesconsult",
      title: "Rådgivende ingeniører med lidenskap for teknisk kvalitet",
      p1: "Norgesconsult AS er et rådgivende ingeniørselskap spesialisert på VVS-prosjektering og BIM. Vi bistår norske rådgivere, entreprenører, byggherrer og leverandører med kapasitet og spesialistkompetanse — med mål om presise, koordinerte og byggbare leveranser tilpasset kundens standarder og prosjektorganisasjon.",
      p2: "Vi prosjekterer varme, kjøling, ventilasjon, sanitær, sprinkler og tekniske sentraler — og leverer beregninger, systemskjemaer, Revit-modeller, arbeidstegninger, mengdegrunnlag og som-bygget dokumentasjon.",
      proTitle: "Ansvarlig prosjekterende (PRO)",
      proText: "Vi kan påta oss ansvarsrett for definerte VVS-ansvarsområder og tiltaksklasser — ett tydelig ansvarspunkt for den avtalte prosjekteringsleveransen.",
      values: [
        { title: "Teknisk presisjon", desc: "Ingen tilfeldigheter i dimensjoneringen. Grundige beregninger gir stabil drift gjennom hele byggets levetid." },
        { title: "Bærekraftig energi", desc: "Vi legger til rette for lavt energiforbruk med varmegjenvinning, varmepumper og behovsstyrte anlegg." },
        { title: "Tett samhandling", desc: "Åpne modeller, raske avklaringer og konstruktive tverrfaglige møter — vi sitter tett på prosjektet." },
      ],
      teamTitle: "Ledelsen",
      teamIntro: "Solid faglig og kommersiell erfaring fra VVS- og energibransjen.",
      team: [
        { id: "mads-kjaeras", name: "Mads A. Kjærås", role: "Daglig leder", bio: "Mange års ledererfaring fra VVS- og industrisektoren i Norge, med fokus på tekniske løsninger, energi og effektiv prosjektleveranse for bygg." },
        { id: "marek-piotrowicz", name: "Marek Piotrowicz", role: "Faglig leder", bio: "30 års erfaring fra HVAC/VVS-prosjektering i Europa. Har ledet tverrfaglige ingeniørteam og levert design for industrielle og kommersielle bygg, inkludert prosjekter i Skandinavia." },
      ],
      collabTitle: "Tre samarbeidsmodeller",
      collabIntro: "Tilpasset kundens kapasitet og ansvar — arbeidsform, verktøy og kontrollpunkter avtales ved oppstart.",
      recommended: "Anbefalt ved tydelig omfang",
      models: [
        { letter: "A", name: "Ressursforsterkning", desc: "Navngitte VVS/BIM-ressurser arbeider i kundens systemer, møter og leveranseplan.", recommended: false },
        { letter: "B", name: "Komplett fagpakke", desc: "Vi leverer et definert VVS-omfang med prosjektledelse, produksjon og intern kontroll.", recommended: true },
        { letter: "C", name: "Produksjon av arbeidstegninger", desc: "Vi produserer klare, koordinerte arbeidstegninger og detaljer — klare for utførelse på byggeplassen.", recommended: false },
      ],
    },
    estimator: {
      badge: "Interaktivt verktøy",
      title: "Estimer VVS-behovet for ditt bygg",
      intro: "Få en rask indikasjon på luftmengde, varme- og kjølebehov basert på areal og bygningstype. Verdiene er kun veiledende — kontakt oss for en faglig gjennomgang av ditt prosjekt.",
      typeLabel: "Bygningstype",
      areaLabel: "Areal (m² BTA)",
      types: { kontor: "Kontor / næringsbygg", bolig: "Bolig / flerfamilie", skole: "Skole / barnehage", industri: "Industri / datasenter" },
      resultsLabel: "Indikativt behov",
      airLabel: "Dimensjonerende luftmengde ventilasjon",
      heatLabel: "Estimert varmebehov",
      coolLabel: "Estimert kjølebehov",
      cta: "Be om faglig vurdering",
    },
    contact: {
      badge: "06 — Ta kontakt",
      title: "La oss diskutere ditt neste prosjekt",
      intro: "Send oss en henvendelse eller tegningsunderlag for en uforpliktende faglig samtale.",
      cards: [
        { label: "E-post", value: "post@norgesconsult.no", href: "mailto:post@norgesconsult.no", testid: "contact-email-link" },
        { label: "Telefon", value: "+47 412 47 400", href: "tel:+4741247400", testid: "contact-phone-link" },
        { label: "Åpningstider", value: "Man–Fre: 08:00–16:00", testid: "contact-hours" },
        { label: "Nettsted", value: "www.norgesconsult.no", testid: "contact-web" },
      ],
      labels: {
        navn: "Fullt navn *",
        firma: "Firma / organisasjon",
        epost: "E-postadresse *",
        telefon: "Telefonnummer",
        tjeneste: "Ønsket tjeneste *",
        melding: "Prosjektbeskrivelse / melding *",
      },
      placeholders: {
        navn: "Ola Nordmann",
        firma: "Firmanavn AS",
        epost: "ola@firma.no",
        telefon: "+47 ...",
        melding: "Fortell kort om prosjektet: bygningstype, areal, fase og hva dere trenger hjelp til.",
      },
      tjenester: ["Komplett VVS-prosjektering", "Ventilasjon / luftbehandling", "Varme og kjøling", "Sanitær og VA i bygg", "Brannbeskyttelse / sprinkler", "Arbeidstegninger / produksjonsunderlag", "BIM / Revit-modellering", "Annet / rådgivning"],
      submit: "Send forespørsel",
      sending: "Sender ...",
      toastSuccess: "Takk for din henvendelse! Vi tar kontakt innen kort tid.",
      toastError: "Noe gikk galt. Prøv igjen, eller send e-post til post@norgesconsult.no.",
    },
    footer: {
      tagline: "Rådgivende ingeniører · VVS-prosjektering · BIM",
      copyright: "© 2026 Norgesconsult AS · Alle rettigheter reservert",
    },
  },

  en: {
    nav: {
      subtitle: "Consulting engineers HVAC",
      home: "Home",
      projects: "Projects",
      services: "Services",
      office: "The office",
      about: "About us",
      contact: "Contact",
      cta: "Get a quote",
    },
    hero: {
      badge: "Consulting engineers · HVAC · BIM",
      headline: ["Precise HVAC", "engineering", "for Norwegian buildings"],
      sub: "Norgesconsult delivers engineering design for heating, cooling, ventilation, plumbing and fire protection — from concept and calculations to coordinated 3D models, construction drawings and as-built documentation.",
      cta1: "Discuss your project",
      cta2: "See reference projects",
      stats: [
        { value: "TK3", label: "Design responsibility", sub: "Heating and cooling systems" },
        { value: "Revit / MagiCAD", label: "Full 3D design", sub: "Collision-checked delivery" },
        { value: "2017–2026", label: "Documented references", sub: "From fire stations to industry" },
      ],
      captionTitle: "Drawing review",
      captionText: "Problem solving across the table — and digitally",
      imageAlt: "Engineers around a meeting table with technical drawings",
    },
    marquee: ["Ventilation", "Heating", "Cooling", "Plumbing", "Fire protection", "BIM / 3D modelling", "Energy optimisation", "Construction drawings"],
    projects: {
      badge: "01 — Reference projects",
      title: "Proven experience from demanding buildings",
      intro: "From mission-critical emergency buildings and schools to heavy industry — our engineers have held lead and design review roles in projects of high technical complexity.",
      featuredLabel: "Key reference",
      list: [
        {
          id: "sandnes-brannstasjon",
          name: "Sandnes fire station – main station",
          client: "Rogaland Fire and Rescue IKS",
          location: "Sandnes",
          year: "2017",
          size: "approx. 12,700 m² · three buildings",
          badge: "Emergency building · Class 3",
          scope: "New main fire station co-located with emergency clinic, ambulance dispatch and urgent care — a mission-critical building with strict requirements for operational reliability.",
          role: "Lead design of heating and cooling systems (class TK3), design review and technical coordination.",
          tech: ["approx. 1.08 MW heating", "450 kW heat pump/chiller", "approx. 570 kW cooling", "Energy wells and free cooling"],
          image: "/projects/brannstasjon.jpg",
          credit: "Photo: Rogaland Fire and Rescue IKS",
        },
        {
          id: "husnes-barneskule",
          name: "New Husnes primary school",
          client: "Kvinnherad municipality",
          location: "Husnes",
          year: "2025",
          size: "approx. 4,200 m² · 250 pupils",
          badge: "School · Passive house",
          scope: "New primary school built to passive house standard with energy class A and expected BREEAM Very Good — handed over three months ahead of schedule.",
          role: "Senior lead engineer and design checker for plumbing, energy and hydronic systems.",
          tech: ["86 kW heat pumps with ground source", "Five energy wells", "Free cooling for air handling units", "135 kW electric peak/backup boiler"],
          image: "/projects/husnes.jpg",
          credit: "Photo: bygg.no / Rune Werner Molnes",
        },
        {
          id: "strand-vgs",
          name: "Strand upper secondary school",
          client: "Rogaland county municipality",
          location: "Tau",
          year: "2025–2026",
          size: "Refurbishment and new build",
          badge: "Education · Ongoing",
          scope: "Expansion and refurbishment of the school towards 800+ pupils, with new workshop facilities for technology, industrial and electrical trades.",
          role: "Senior lead engineer, design review and technical coordination of the HVAC design documentation.",
          tech: ["Calculated heat demand approx. 268 kW", "Central heat exchanger 305 kW", "Five hydronic systems", "100 kW electric peak/backup boiler"],
          image: "/projects/strand-vgs.png",
          credit: "Illustration: Rogaland county municipality",
        },
        {
          id: "pepsico-copernicus",
          name: "PepsiCo Frito-Lay – “Copernicus”",
          client: "PepsiCo / Frito-Lay",
          location: "Środa Śląska, Poland",
          year: "2020–2023",
          size: "approx. 54,700 m² production and warehouse",
          badge: "Industry · Process cooling",
          scope: "Large industrial production and warehouse facility for food production — among the most sustainable plants of its kind in Europe.",
          role: "HVAC concept design lead, design review and detailed engineering of the cooling system.",
          tech: ["Cooling plant approx. 4.2 MW", "2.28 MW absorption chiller", "2 × 783 kW screw chillers (backup)", "Cooling towers, hydraulics and redundancy"],
          image: "/projects/pepsico.jpg",
          credit: "Photo: wroclaw.pl",
        },
        {
          id: "svortland-legesenter",
          name: "Øyane Helsehamn – medical centre",
          client: "Hellvik Eiendom AS",
          location: "Svortland, Bømlo",
          year: "2024",
          size: "approx. 1,000 m² · 12 GP offices",
          badge: "Healthcare · Medical centre",
          scope: "New medical centre with 12 GP offices, laboratory and ultrasound rooms — co-locating the Kystlegane and Bremnes practices under one roof.",
          role: "Senior lead engineer and design checker for the technical systems.",
          tech: ["Low-temperature hydronic floor heating", "Local cooling systems", "Energy-efficient operation"],
          image: "/projects/svortland.jpg",
          credit: "Photo: Simon Knutsson Sortland / Bømlo municipality",
        },
      ],
    },
    services: {
      badge: "02 — Complete HVAC delivery",
      title: "Our HVAC engineering services",
      intro: "From calculations and system selection to Revit models, construction drawings, fabrication documentation and as-built documentation.",
      showDetails: "Show details",
      hideDetails: "Hide details",
      items: [
        {
          id: "ventilasjon",
          code: "HVAC-01",
          name: "Ventilation and air handling",
          short: "Air volumes, air handling units, shafts and coordinated ductwork for a healthy indoor climate.",
          details: ["Calculation of air volumes and pressure drops", "Sizing of air handling units and ductwork in 3D", "Coordination of shafts and technical rooms", "Fire strategy and interdisciplinary coordination"],
        },
        {
          id: "varme",
          code: "HVAC-02",
          name: "Heating and cooling",
          short: "Energy centres, heat pumps, chillers, district heating and hydronic distribution systems.",
          details: ["Hydraulics, capacities and pipe sizing", "Pressure drop calculations and balancing", "Heat pumps, heat exchangers and peak load", "Technical centres and energy distribution"],
        },
        {
          id: "sanitar",
          code: "HVAC-03",
          name: "Plumbing and drainage",
          short: "Domestic water, drainage, stormwater, pump stations and technical rooms.",
          details: ["Sizing of domestic water and circulation", "Wastewater, venting and stormwater management", "Booster and pump stations", "System solutions for demanding buildings"],
        },
        {
          id: "brann",
          code: "HVAC-04",
          name: "Fire protection",
          short: "Sprinkler, hydrant and fire suppression systems with the necessary interdisciplinary coordination.",
          details: ["Sprinkler systems to current standards", "Hydrant and suppression systems", "Coordination with architecture and structure", "Documentation for the fire concept"],
        },
        {
          id: "arbeidstegninger",
          code: "HVAC-05",
          name: "Construction drawings and documentation",
          short: "Clear, coordinated construction drawings and technical documentation — ready for installation.",
          details: ["Production of construction drawings and details", "System schematics and functional descriptions", "Documentation tailored to contractors and site", "Revision and quality control before issue"],
        },
        {
          id: "bim",
          code: "HVAC-06",
          name: "BIM and advisory",
          short: "Revit/MagiCAD, model review, clash detection, quantities and BIM coordination.",
          details: ["Discipline model with correct geometry and data", "Clash detection and deviation follow-up", "Quantity take-off and component schedules", "BIM coordination with other disciplines"],
        },
      ],
    },
    carousel: {
      badge: "03 — Inside the office",
      title: "How we work — every single day",
      intro: "Drawings on the meeting table, 3D models on the screens and professional discussions. This is where buildable solutions are made.",
      slides: [
        {
          title: "Problem solving around the table",
          category: "DETAIL DESIGN",
          description: "The best solutions are created when people meet — around the table with drawings and drafts, and digitally in the shared model. We point, discuss routing and clarify interfaces with architecture, structure and electrical before the documents are issued.",
          badge: "Around the table · Digital · Interdisciplinary review",
        },
        {
          title: "3D and BIM modelling",
          category: "DIGITAL BUILDING MODEL",
          description: "Ventilation ducts, pipe routes and technical rooms are modelled in Revit and MagiCAD with millimetre precision — clashes are resolved on screen, not on site.",
          badge: "Revit MEP · MagiCAD · Clash detection",
        },
        {
          title: "Calculations at the drawing board",
          category: "SYSTEM DESIGN",
          description: "Pressure drops, air volumes and sizing are calculated and reviewed by experienced engineers before the documentation goes to design review and approval.",
          badge: "Air volumes · Sizing · System analysis",
        },
        {
          title: "From drawing to technical installation",
          category: "HVAC IN PRACTICE",
          description: "What we draw must be buildable. Pipe routes, manifold distributors and technical centres are detailed so the installer can mount directly from the documentation — no guesswork on site.",
          badge: "Technical rooms · Pipe routes · Buildable documents",
        },
      ],
    },
    process: {
      badge: "04 — Our process",
      title: "From kick-off to approved delivery",
      steps: [
        { title: "Kick-off and requirements", desc: "We clarify scope, standards, milestones and interfaces." },
        { title: "Calculation and system design", desc: "Assumptions, capacities and technical principles are documented." },
        { title: "BIM model and coordination", desc: "Revit/MagiCAD, clash detection and interdisciplinary clarifications." },
        { title: "Design review and issue", desc: "Checklists, revision control and approved drawing package." },
        { title: "Follow-up and as-built", desc: "Changes are incorporated and final documentation completed." },
      ],
      deliverablesLabel: "Typical delivery package:",
      deliverables: ["Calculations", "BIM model", "Schematics", "Drawings", "Quantities", "QA trail"],
    },
    about: {
      badge: "05 — About Norgesconsult",
      title: "Consulting engineers with a passion for technical quality",
      p1: "Norgesconsult AS is a consulting engineering company specialised in HVAC design and BIM. We support Norwegian consultants, contractors, developers and suppliers with capacity and specialist expertise — aiming for precise, coordinated and buildable deliveries adapted to the client's standards and project organisation.",
      p2: "We design heating, cooling, ventilation, plumbing, sprinkler and technical centres — and deliver calculations, system schematics, Revit models, construction drawings, quantity documentation and as-built documentation.",
      proTitle: "Responsible designer (PRO)",
      proText: "We can assume statutory design responsibility for defined HVAC scopes and responsibility classes — one clear point of responsibility for the agreed design delivery.",
      values: [
        { title: "Technical precision", desc: "No coincidences in the sizing. Thorough calculations provide stable operation throughout the building's lifetime." },
        { title: "Sustainable energy", desc: "We enable low energy consumption with heat recovery, heat pumps and demand-controlled systems." },
        { title: "Close collaboration", desc: "Open models, fast clarifications and constructive interdisciplinary meetings — we stay close to the project." },
      ],
      teamTitle: "Leadership",
      teamIntro: "Solid technical and commercial experience from the HVAC and energy sector.",
      team: [
        { id: "mads-kjaeras", name: "Mads A. Kjærås", role: "Managing Director", bio: "Many years of management experience from the HVAC and industrial sectors in Norway, focusing on technical solutions, energy and efficient project delivery for buildings." },
        { id: "marek-piotrowicz", name: "Marek Piotrowicz", role: "Technical Director", bio: "30 years of experience from HVAC design across Europe. Has led multidisciplinary engineering teams and delivered designs for industrial and commercial buildings, including projects in Scandinavia." },
      ],
      collabTitle: "Three collaboration models",
      collabIntro: "Adapted to the client's capacity and responsibility — ways of working, tools and checkpoints are agreed at kick-off.",
      recommended: "Recommended for defined scopes",
      models: [
        { letter: "A", name: "Resource augmentation", desc: "Named HVAC/BIM resources work in the client's systems, meetings and delivery plan.", recommended: false },
        { letter: "B", name: "Complete discipline package", desc: "We deliver a defined HVAC scope with project management, production and internal review.", recommended: true },
        { letter: "C", name: "Production of construction drawings", desc: "We produce clear, coordinated construction drawings and details — ready for installation on site.", recommended: false },
      ],
    },
    estimator: {
      badge: "Interactive tool",
      title: "Estimate the HVAC needs of your building",
      intro: "Get a quick indication of airflow, heating and cooling demand based on floor area and building type. Values are indicative only — contact us for a professional review of your project.",
      typeLabel: "Building type",
      areaLabel: "Area (m² GFA)",
      types: { kontor: "Office / commercial", bolig: "Residential / multi-family", skole: "School / kindergarten", industri: "Industry / data centre" },
      resultsLabel: "Indicative demand",
      airLabel: "Design ventilation airflow",
      heatLabel: "Estimated heating demand",
      coolLabel: "Estimated cooling demand",
      cta: "Request a professional assessment",
    },
    contact: {
      badge: "06 — Get in touch",
      title: "Let's discuss your next project",
      intro: "Send us an enquiry or drawing package for a no-obligation technical conversation.",
      cards: [
        { label: "Email", value: "post@norgesconsult.no", href: "mailto:post@norgesconsult.no", testid: "contact-email-link" },
        { label: "Phone", value: "+47 412 47 400", href: "tel:+4741247400", testid: "contact-phone-link" },
        { label: "Opening hours", value: "Mon–Fri: 08:00–16:00", testid: "contact-hours" },
        { label: "Website", value: "www.norgesconsult.no", testid: "contact-web" },
      ],
      labels: {
        navn: "Full name *",
        firma: "Company / organisation",
        epost: "Email address *",
        telefon: "Phone number",
        tjeneste: "Service needed *",
        melding: "Project description / message *",
      },
      placeholders: {
        navn: "John Smith",
        firma: "Company Ltd",
        epost: "john@company.com",
        telefon: "+47 ...",
        melding: "Briefly describe the project: building type, size, phase and what you need help with.",
      },
      tjenester: ["Complete HVAC design", "Ventilation / air handling", "Heating and cooling", "Plumbing and drainage", "Fire protection / sprinkler", "Construction drawings / documentation", "BIM / Revit modelling", "Other / advisory"],
      submit: "Send enquiry",
      sending: "Sending ...",
      toastSuccess: "Thank you for your enquiry! We will get back to you shortly.",
      toastError: "Something went wrong. Please try again, or email post@norgesconsult.no.",
    },
    footer: {
      tagline: "Consulting engineers · HVAC design · BIM",
      copyright: "© 2026 Norgesconsult AS · All rights reserved",
    },
  },

  pl: {
    nav: {
      subtitle: "Inżynierowie konsultanci HVAC",
      home: "Start",
      projects: "Projekty",
      services: "Usługi",
      office: "Biuro",
      about: "O nas",
      contact: "Kontakt",
      cta: "Poproś o wycenę",
    },
    hero: {
      badge: "Inżynierowie konsultanci · HVAC · BIM",
      headline: ["Precyzyjna projektacja", "instalacji HVAC", "dla norweskich budynków"],
      sub: "Norgesconsult realizuje projektowanie instalacji grzewczych, chłodniczych, wentylacyjnych, sanitarnych i przeciwpożarowych — od koncepcji i obliczeń po skoordynowane modele 3D, rysunki wykonawcze i dokumentację powykonawczą.",
      cta1: "Omów swój projekt",
      cta2: "Zobacz referencje",
      stats: [
        { value: "TK3", label: "Odpowiedzialność projektowa", sub: "Instalacje grzewcze i chłodnicze" },
        { value: "Revit / MagiCAD", label: "Pełne projektowanie 3D", sub: "Dostawa po kontroli kolizji" },
        { value: "2017–2026", label: "Udokumentowane referencje", sub: "Od remiz strażackich po przemysł" },
      ],
      captionTitle: "Przegląd rysunków",
      captionText: "Rozwiązujemy problemy przy stole — i cyfrowo",
      imageAlt: "Inżynierowie przy stole konferencyjnym z rysunkami technicznymi",
    },
    marquee: ["Wentylacja", "Ogrzewanie", "Chłodzenie", "Instalacje sanitarne", "Instalacje ppoż.", "BIM / modelowanie 3D", "Optymalizacja energetyczna", "Rysunki wykonawcze"],
    projects: {
      badge: "01 — Projekty referencyjne",
      title: "Udokumentowane doświadczenie w wymagających budynkach",
      intro: "Od budynków służb ratunkowych i szkół po wielki przemysł — nasi inżynierowie pełnili role prowadzące i kontrolne w projektach o wysokiej złożoności technicznej.",
      featuredLabel: "Główna referencja",
      list: [
        {
          id: "sandnes-brannstasjon",
          name: "Remiza strażacka Sandnes – stacja główna",
          client: "Rogaland brann og redning IKS",
          location: "Sandnes",
          year: "2017",
          size: "ok. 12 700 m² · trzy budynki",
          badge: "Budynek ratowniczy · Klasa 3",
          scope: "Nowa stacja główna zintegrowana z izbą przyjęć, centrum dyspozytorskim ambulansów i pomocą doraźną — budynek o krytycznym znaczeniu z wysokimi wymaganiami niezawodności.",
          role: "Projektowanie prowadzące instalacji grzewczych i chłodniczych (TK3), kontrola projektu i koordynacja techniczna.",
          tech: ["ok. 1,08 MW ciepła", "Pompa ciepła/chiller 450 kW", "ok. 570 kW chłodu", "Studnie energetyczne i free cooling"],
          image: "/projects/brannstasjon.jpg",
          credit: "Zdjęcie: Rogaland brann og redning IKS",
        },
        {
          id: "husnes-barneskule",
          name: "Nowa szkoła podstawowa w Husnes",
          client: "Gmina Kvinnherad",
          location: "Husnes",
          year: "2025",
          size: "ok. 4 200 m² · 250 uczniów",
          badge: "Szkoła · Budynek pasywny",
          scope: "Nowa szkoła podstawowa w standardzie pasywnym, klasa energetyczna A i oczekiwany BREEAM Very Good — oddana trzy miesiące przed terminem.",
          role: "Senior lead engineer i kontroler projektu (design checker) instalacji sanitarnych, energetycznych i hydronicznych.",
          tech: ["Pompy ciepła 86 kW z gruntowym źródłem", "Pięć studni energetycznych", "Free cooling dla central wentylacyjnych", "Elektryczny kocioł szczytowy 135 kW"],
          image: "/projects/husnes.jpg",
          credit: "Zdjęcie: bygg.no / Rune Werner Molnes",
        },
        {
          id: "strand-vgs",
          name: "Liceum ogólnokształcące Strand",
          client: "Rogaland fylkeskommune",
          location: "Tau",
          year: "2025–2026",
          size: "Rozbudowa i modernizacja",
          badge: "Edukacja · W realizacji",
          scope: "Rozbudowa i modernizacja szkoły do ponad 800 uczniów, z nowymi warsztatami dla kierunków technicznych, przemysłowych i elektrycznych.",
          role: "Senior lead engineer, kontrola projektu i koordynacja techniczna dokumentacji HVAC.",
          tech: ["Obliczeniowe zapotrzebowanie ok. 268 kW", "Centralny wymiennik 305 kW", "Pięć systemów hydronicznych", "Elektryczny kocioł szczytowy 100 kW"],
          image: "/projects/strand-vgs.png",
          credit: "Ilustracja: Rogaland fylkeskommune",
        },
        {
          id: "pepsico-copernicus",
          name: "PepsiCo Frito-Lay – „Copernicus”",
          client: "PepsiCo / Frito-Lay",
          location: "Środa Śląska, Polska",
          year: "2020–2023",
          size: "ok. 54 700 m² produkcji i magazynu",
          badge: "Przemysł · Chłodzenie procesowe",
          scope: "Duży zakład produkcyjno-magazynowy branży spożywczej — jeden z najbardziej zrównoważonych obiektów tego typu w Europie.",
          role: "HVAC concept design lead, kontrola projektu i projektowanie szczegółowe systemu chłodzenia.",
          tech: ["Centrala chłodnicza ok. 4,2 MW", "Chiller absorpcyjny 2,28 MW", "2 × 783 kW chillery śrubowe (rezerwa)", "Chłodnie kominowe, hydraulika i redundancja"],
          image: "/projects/pepsico.jpg",
          credit: "Zdjęcie: wroclaw.pl",
        },
        {
          id: "svortland-legesenter",
          name: "Øyane Helsehamn – przychodnia",
          client: "Hellvik Eiendom AS",
          location: "Svortland, Bømlo",
          year: "2024",
          size: "ok. 1 000 m² · 12 gabinetów lekarskich",
          badge: "Ochrona zdrowia · Przychodnia",
          scope: "Nowa przychodnia z 12 gabinetami lekarskimi, laboratorium i pracownią USG — połączenie przychodni Kystlegane i Bremnes pod jednym dachem.",
          role: "Senior lead engineer i kontroler projektu (design checker) instalacji technicznych.",
          tech: ["Niskotemperaturowe ogrzewanie podłogowe", "Lokalne systemy chłodzenia", "Energooszczędna eksploatacja"],
          image: "/projects/svortland.jpg",
          credit: "Zdjęcie: Simon Knutsson Sortland / Gmina Bømlo",
        },
      ],
    },
    services: {
      badge: "02 — Kompletna dostawa HVAC",
      title: "Nasze usługi projektowania instalacji",
      intro: "Od obliczeń i doboru systemów po modele Revit, rysunki wykonawcze, dokumentację produkcyjną i dokumentację powykonawczą.",
      showDetails: "Pokaż szczegóły",
      hideDetails: "Ukryj szczegóły",
      items: [
        {
          id: "ventilasjon",
          code: "HVAC-01",
          name: "Wentylacja i obróbka powietrza",
          short: "Strumienie powietrza, centrale wentylacyjne, szychy i skoordynowane kanały dla dobrego klimatu wewnętrznego.",
          details: ["Obliczenia strumieni powietrza i spadków ciśnienia", "Dobór central i kanałów w 3D", "Koordynacja szychów i pomieszczeń technicznych", "Strategia ppoż. i koordynacja międzybranżowa"],
        },
        {
          id: "varme",
          code: "HVAC-02",
          name: "Ogrzewanie i chłodzenie",
          short: "Centrale energetyczne, pompy ciepła, chillery, ciepło sieciowe i systemy wodne.",
          details: ["Hydraulika, moce i dobór średnic rur", "Obliczenia oporów i regulacja hydrauliczna", "Pompy ciepła, wymienniki i źródła szczytowe", "Centrale techniczne i dystrybucja energii"],
        },
        {
          id: "sanitar",
          code: "HVAC-03",
          name: "Instalacje sanitarne i wod-kan",
          short: "Woda użytkowa, kanalizacja, wody deszczowe, pompownie i pomieszczenia techniczne.",
          details: ["Dobór instalacji wody użytkowej i cyrkulacji", "Ścieki, wentylacja i gospodarka wodami deszczowymi", "Zestawy hydroforowe i pompownie", "Rozwiązania systemowe dla wymagających budynków"],
        },
        {
          id: "brann",
          code: "HVAC-04",
          name: "Ochrona przeciwpożarowa",
          short: "Instalacje tryskaczowe, hydrantowe i gaśnicze z koordynacją międzybranżową.",
          details: ["Instalacje tryskaczowe wg obowiązujących norm", "Instalacje hydrantowe i gaśnicze", "Koordynacja z architekturą i konstrukcją", "Dokumentacja koncepcji ppoż."],
        },
        {
          id: "arbeidstegninger",
          code: "HVAC-05",
          name: "Rysunki wykonawcze i dokumentacja",
          short: "Przejrzyste, skoordynowane rysunki wykonawcze i dokumentacja — gotowe do montażu.",
          details: ["Produkcja rysunków wykonawczych i detali", "Schematy systemów i opisy funkcjonalne", "Dokumentacja dopasowana do wykonawcy i budowy", "Rewizja i kontrola jakości przed publikacją"],
        },
        {
          id: "bim",
          code: "HVAC-06",
          name: "BIM i doradztwo",
          short: "Revit/MagiCAD, kontrola modelu, analiza kolizji, przedmiary i koordynacja BIM.",
          details: ["Model branżowy z poprawną geometrią i danymi", "Kontrola kolizji i śledzenie odchyleń", "Przedmiary i zestawienia komponentów", "Koordynacja BIM z pozostałymi branżami"],
        },
      ],
    },
    carousel: {
      badge: "03 — W naszym biurze",
      title: "Tak pracujemy — każdego dnia",
      intro: "Rysunki na stole konferencyjnym, modele 3D na ekranach i merytoryczne dyskusje. To tutaj powstają rozwiązania możliwe do zbudowania.",
      slides: [
        {
          title: "Rozwiązywanie problemów przy stole",
          category: "PROJEKT WYKONAWCZY",
          description: "Najlepsze rozwiązania powstają w spotkaniu ludzi — przy stole z rysunkami i szkicami oraz cyfrowo we wspólnym modelu. Wskazujemy, omawiamy trasy prowadzenia i wyjaśniamy granice branż z architekturą, konstrukcją i elektryką przed publikacją dokumentacji.",
          badge: "Przy stole · Cyfrowo · Kontrola międzybranżowa",
        },
        {
          title: "Modelowanie 3D i BIM",
          category: "CYFROWY MODEL BUDYNKU",
          description: "Kanały wentylacyjne, trasy rurowe i pomieszczenia techniczne modelujemy w Revit i MagiCAD z dokładnością do milimetra — kolizje rozwiązujemy na ekranie, nie na budowie.",
          badge: "Revit MEP · MagiCAD · Kontrola kolizji",
        },
        {
          title: "Obliczenia przy desce kreślarskiej",
          category: "PROJEKTOWANIE SYSTEMÓW",
          description: "Spadki ciśnienia, strumienie powietrza i doboru dokonują oraz weryfikują doświadczeni doradcy, zanim dokumentacja trafi do kontroli i zatwierdzenia.",
          badge: "Strumienie · Dobory · Analiza systemów",
        },
        {
          title: "Od rysunku do instalacji technicznej",
          category: "INSTALACJE W PRAKTYCE",
          description: "To, co rysujemy, musi dać się zbudować. Trasy rurowe, rozdzielacze i centrale techniczne projektujemy szczegółowo, aby monter mógł pracować bezpośrednio z dokumentacji — bez zgadywania na budowie.",
          badge: "Pomieszczenia techniczne · Trasy rurowe · Dokumentacja wykonawcza",
        },
      ],
    },
    process: {
      badge: "04 — Nasz proces",
      title: "Od uruchomienia do zatwierdzonej dostawy",
      steps: [
        { title: "Uruchomienie i wyjaśnienie wymagań", desc: "Wyjaśniamy zakres, normy, kamienie milowe i granice branż." },
        { title: "Obliczenia i projekt systemu", desc: "Założenia, moce i zasady techniczne zostają udokumentowane." },
        { title: "Model BIM i koordynacja", desc: "Revit/MagiCAD, kontrola kolizji i uzgodnienia międzybranżowe." },
        { title: "Kontrola i publikacja", desc: "Listy kontrolne, kontrola rewizji i zatwierdzony pakiet rysunków." },
        { title: "Nadzór i dokumentacja powykonawcza", desc: "Zmiany są wprowadzane, a dokumentacja końcowa finalizowana." },
      ],
      deliverablesLabel: "Typowy pakiet dostawy:",
      deliverables: ["Obliczenia", "Model BIM", "Schematy", "Rysunki", "Przedmiary", "Ślad kontroli"],
    },
    about: {
      badge: "05 — O Norgesconsult",
      title: "Inżynierowie konsultanci z pasją do jakości technicznej",
      p1: "Norgesconsult AS to firma inżyniersko-konsultingowa wyspecjalizowana w projektowaniu HVAC i BIM. Wspieramy norweskich projektantów, wykonawców, inwestorów i dostawców mocami i kompetencjami specjalistycznymi — z celem precyzyjnych, skoordynowanych i wykonalnych dostaw dopasowanych do standardów i organizacji klienta.",
      p2: "Projektujemy ogrzewanie, chłodzenie, wentylację, instalacje sanitarne, tryskaczowe i centrale techniczne — dostarczamy obliczenia, schematy, modele Revit, rysunki wykonawcze, przedmiary i dokumentację powykonawczą.",
      proTitle: "Projektant odpowiedzialny (PRO)",
      proText: "Możemy przejąć ustawową odpowiedzialność projektową za określone zakresy HVAC i klasy odpowiedzialności — jeden jasny punkt odpowiedzialności za uzgodnioną dostawę projektową.",
      values: [
        { title: "Precyzja techniczna", desc: "Żadnych przypadków w doborach. Rzetelne obliczenia zapewniają stabilną pracę przez cały cykl życia budynku." },
        { title: "Zrównoważona energia", desc: "Umożliwiamy niskie zużycie energii dzięki odzyskowi ciepła, pompom ciepła i systemom sterowanym zapotrzebowaniem." },
        { title: "Ścisła współpraca", desc: "Otwarte modele, szybkie uzgodnienia i konstruktywne spotkania międzybranżowe — jesteśmy blisko projektu." },
      ],
      teamTitle: "Zarząd",
      teamIntro: "Solidne doświadczenie techniczne i komercyjne z branży HVAC i energetyki.",
      team: [
        { id: "mads-kjaeras", name: "Mads A. Kjærås", role: "Prezes zarządu", bio: "Wieloletnie doświadczenie menedżerskie w branży HVAC i przemysłowej w Norwegii, ze szczególnym uwzględnieniem rozwiązań technicznych, energetyki i efektywnej realizacji projektów budowlanych." },
        { id: "marek-piotrowicz", name: "Marek Piotrowicz", role: "Dyrektor techniczny", bio: "30 lat doświadczenia w projektowaniu instalacji HVAC w Europie. Prowadził międzybranżowe zespoły inżynierskie i dostarczał projekty dla budynków przemysłowych i komercyjnych, w tym w Skandynawii." },
      ],
      collabTitle: "Trzy modele współpracy",
      collabIntro: "Dopasowane do możliwości i odpowiedzialności klienta — forma pracy, narzędzia i punkty kontrolne ustalamy przy starcie.",
      recommended: "Zalecane przy jasnym zakresie",
      models: [
        { letter: "A", name: "Wzmocnienie zespołu", desc: "Wskazani specjaliści HVAC/BIM pracują w systemach, spotkaniach i harmonogramie klienta.", recommended: false },
        { letter: "B", name: "Kompletny pakiet branżowy", desc: "Dostarczamy zdefiniowany zakres HVAC z zarządzaniem projektem, produkcją i wewnętrzną kontrolą.", recommended: true },
        { letter: "C", name: "Produkcja rysunków wykonawczych", desc: "Produkujemy przejrzyste, skoordynowane rysunki wykonawcze i detale — gotowe do realizacji na budowie.", recommended: false },
      ],
    },
    estimator: {
      badge: "Interaktywne narzędzie",
      title: "Oszacuj zapotrzebowanie HVAC swojego budynku",
      intro: "Uzyskaj szybkie wskazanie strumienia powietrza oraz zapotrzebowania na ciepło i chłód na podstawie powierzchni i typu budynku. Wartości są orientacyjne — skontaktuj się z nami w celu fachowej oceny projektu.",
      typeLabel: "Typ budynku",
      areaLabel: "Powierzchnia (m²)",
      types: { kontor: "Biuro / komercyjny", bolig: "Mieszkaniowy / wielorodzinny", skole: "Szkoła / przedszkole", industri: "Przemysł / centrum danych" },
      resultsLabel: "Szacunkowe zapotrzebowanie",
      airLabel: "Obliczeniowy strumień wentylacji",
      heatLabel: "Szacunkowe zapotrzebowanie na ciepło",
      coolLabel: "Szacunkowe zapotrzebowanie na chłód",
      cta: "Poproś o ocenę specjalisty",
    },
    contact: {
      badge: "06 — Skontaktuj się",
      title: "Porozmawiajmy o Twoim kolejnym projekcie",
      intro: "Wyślij zapytanie lub dokumentację rysunkową, a umówimy się na niezobowiązującą rozmowę techniczną.",
      cards: [
        { label: "E-mail", value: "post@norgesconsult.no", href: "mailto:post@norgesconsult.no", testid: "contact-email-link" },
        { label: "Telefon", value: "+47 412 47 400", href: "tel:+4741247400", testid: "contact-phone-link" },
        { label: "Godziny pracy", value: "Pn–Pt: 08:00–16:00", testid: "contact-hours" },
        { label: "Strona www", value: "www.norgesconsult.no", testid: "contact-web" },
      ],
      labels: {
        navn: "Imię i nazwisko *",
        firma: "Firma / organizacja",
        epost: "Adres e-mail *",
        telefon: "Numer telefonu",
        tjeneste: "Wymagana usługa *",
        melding: "Opis projektu / wiadomość *",
      },
      placeholders: {
        navn: "Jan Kowalski",
        firma: "Nazwa firmy Sp. z o.o.",
        epost: "jan@firma.pl",
        telefon: "+48 ...",
        melding: "Opisz krótko projekt: typ budynku, powierzchnia, faza i czego potrzebujecie.",
      },
      tjenester: ["Kompletny projekt HVAC", "Wentylacja / obróbka powietrza", "Ogrzewanie i chłodzenie", "Instalacje sanitarne i wod-kan", "Ochrona ppoż. / tryskacze", "Rysunki wykonawcze / dokumentacja", "BIM / modelowanie Revit", "Inne / doradztwo"],
      submit: "Wyślij zapytanie",
      sending: "Wysyłanie ...",
      toastSuccess: "Dziękujemy za zapytanie! Skontaktujemy się wkrótce.",
      toastError: "Coś poszło nie tak. Spróbuj ponownie lub napisz na post@norgesconsult.no.",
    },
    footer: {
      tagline: "Inżynieria konsultingowa · Projektowanie HVAC · BIM",
      copyright: "© 2026 Norgesconsult AS · Wszelkie prawa zastrzeżone",
    },
  },
};
